/* eslint-disable no-use-before-define */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    Paper,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useMessageDispatcher from '../../../hooks/useMessageDispatcher';
import axios from 'axios';
import MainCard from 'ui-component/cards/MainCard';
import DataNotAvailablePage from 'reusable-components/data-not-found';
import moment from 'moment';

const headers = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken') || window.localStorage.getItem('webViewToken')}`,
        'Content-Type': 'application/json'
    }
};
const LabelledField = ({ label, children, labelWidth = '190px' }) => (
    <Box
        mb={1.5}
        sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { sm: 'center' },
            gap: 1
        }}
    >
        <Typography sx={{ width: { xs: '100%', sm: labelWidth }, fontSize: '14px', fontWeight: 'bold' }}>{label}</Typography>
        {children}
    </Box>
);

const CustomTextField = (props) => (
    <TextField
        variant="standard"
        fullWidth
        size="small"
        InputProps={{
            style: {
                fontSize: '0.85rem',
                padding: 0,
                disableUnderline: false
            }
        }}
        sx={{
            bgcolor: 'rgba(255, 255, 255, 0.7)',
            '& .MuiOutlinedInput-root': {
                borderRadius: 0,
                '& fieldset': {
                    border: '1px solid #2a4582',
                    borderRadius: 0
                },
                '&:hover fieldset': {
                    border: '1px solid #2a4582'
                },
                '&.Mui-focused fieldset': {
                    border: '1px solid #2a4582'
                }
            }
        }}
        {...props}
    />
);
const currentDate = moment().format('DD MMM YYYY');
const Sports = () => {
    const location = useLocation();
    const studentData = location.state?.studentData;
    const isMobile = useMediaQuery('(max-width:600px)');
    const [isLoading, setIsLoading] = useState(false);
    const [sports, setSports] = useState([]);
    const [selectedSports, setSelectedSports] = useState([]);
    const [totalSportsAmount, setTotalSportsAmount] = useState(0);
    const [openSports, setOpenSports] = useState(false);
    const [sportsSubscriptionId, setSportsSubscriptionId] = useState('');
    const [signature, setSignature] = useState('');
    const [sportInfo, setSportInfo] = useState(studentData?.sportInfo || { injury: '', participationList: [] });
    const navigate = useNavigate();
    const showMessage = useMessageDispatcher();

    const fetchSignature = async (fileName) => {
        axios.post(`/v1/utils/file/download`, { fileName }, headers).then((result) => {
            setSignature(result.data.data);
        });
    };
    const fetchIntrestCategories = async () => {
        try {
            const response = await axios.get(
                `/v1/fees/expression-of-interest-category-fees?interestType=SPORTS&batchId=${studentData?.sessionId}`,
                headers
            );
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    const data = response?.data?.data;
                    const newData = data?.map((item) => item?.subHeads).flat();
                    setSports(newData);
                    fetchSubscriptions();
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const handleSubscription = async () => {
        const payload = {
            interestType: 'SPORTS',
            subscriptionItems: selectedSports,
            userId: studentData?.userId,
            sportInfo
        };
        try {
            setIsLoading(true);
            const response = await axios.post(`/v1/fees/expression-of-interest-subscription`, payload, headers);
            if (response.status === 200) {
                navigate(-1);
                setIsLoading(false);
                fetchSubscriptions();
                if (response.data.code !== '403') {
                    showMessage({ message: response?.data?.Msg, color: 'success' });
                }
            }
        } catch (error) {
            setIsLoading(false);
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchSubscriptions = async () => {
        try {
            const response = await axios.get(
                `/v1/fees/expression-of-interest-subscription-details-by-user?userId=${studentData?.userId}`,
                headers
            );
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    const data = response?.data?.data;
                    const sportsSubscriptionId = data?.find((item) => item?.interestType === 'SPORTS')?.id;
                    const sportsDetails = data
                        ?.flatMap((item) => item?.subscriptionDetailsList || [])
                        ?.filter((elem) => elem?.subscriptionItem?.interestType === 'SPORTS')
                        ?.flatMap((el) => el?.subscriptionItem?.id?.toString());
                    const sportsTotal = calculateTotalAmount(sports, sportsDetails);
                    setTotalSportsAmount(sportsTotal);
                    setSelectedSports(sportsDetails);
                    setSportsSubscriptionId(sportsSubscriptionId);
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const cancelSubscription = async (subscriptionId) => {
        try {
            const response = await axios.put(
                `/v1/fees/subscription-remove-for-admission?userId=${studentData?.userId}&subscriptionId=${subscriptionId}`,
                {},
                headers
            );
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    showMessage({ message: response?.data?.Msg, color: 'error' });
                    setSelectedSports([]);
                    setOpenSports(false);
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const calculateTotalAmount = (feeHeads, selectedIds) =>
        feeHeads?.reduce((total, item) => {
            const amountString = String(item?.amount || '0');
            if (selectedIds?.includes(item?.id?.toString())) {
                const fee = parseFloat(amountString?.replace(/[^\d.]/g, ''));
                if (!isNaN(fee)) {
                    return total + fee;
                }
            }
            return total;
        }, 0);
    useEffect(() => {
        fetchIntrestCategories();
        if (studentData?.studentSignature || studentData?.declarations[0]?.signatureFile)
            fetchSignature(studentData?.studentSignature || studentData?.declarations[0]?.signatureFile);
    }, []);

    useEffect(() => {
        const sportsTotal = calculateTotalAmount(sports, selectedSports);
        setTotalSportsAmount(sportsTotal);
    }, [selectedSports]);
    return (
        <MainCard>
            <Paper
                elevation={3}
                sx={{ p: 4, maxWidth: 900, mx: 'auto', my: 4, backgroundColor: 'linear-gradient(135deg, #e6e9f0 0%, #d2d4e2 100%)' }}
            >
                <div
                    style={{
                        textAlign: 'center',
                        marginBottom: '20px',
                        borderBottom: '2px solid #2a4582',
                        paddingBottom: '10px'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '16px',
                            backgroundColor: 'linear-gradient(135deg, #e6e9f0 0%, #d2d4e2 100%)'
                        }}
                    >
                        <img
                            src="/UniversityHeader.png"
                            alt="University Header"
                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                backgroundColor: 'linear-gradient(135deg, #e6e9f0 0%, #d2d4e2 100%)'
                            }}
                        />
                    </div>
                    <h2
                        style={{
                            fontSize: '18px',
                            color: '#2a4582',
                            marginTop: '15px',
                            fontWeight: 'bold'
                        }}
                    >
                        SPORTS EXCELLENCE PROGRAM
                        <br />
                        Expression of Interest
                    </h2>
                </div>
                <div
                    style={{
                        fontSize: '14px',
                        marginBottom: '20px',
                        textAlign: 'justify',
                        lineHeight: '1.4'
                    }}
                >
                    <p>
                        Sports excellence program (SEP) is a specialized program for students who are interested in Sports and Sportsman.
                        The SEP provides opportunities to train under certified well-known result oriented coaches in supervised regular
                        training schedule to those athletes who opted any two sports for entire tenure of their life course of study. The
                        SEP Athletes also have regular access to other top-class facilities and infrastructure tied up with USTM.
                    </p>
                    <p>
                        The main aims and objectives of SEP are to achieve consistent success in the States Championship, National
                        Championship, All Indian Universality meet, Asian Championship, Commonwealth Games, World Championship and most
                        importantly for Olympic games.
                    </p>
                </div>
                {sports?.length === 0 ? (
                    <DataNotAvailablePage text="No Data Found!" />
                ) : (
                    <div
                        style={{
                            marginBottom: '20px'
                        }}
                    >
                        <h3
                            style={{
                                color: '#2a4582',
                                fontSize: '16px',
                                marginBottom: '10px',
                                textTransform: 'uppercase'
                            }}
                        >
                            SPORTS CATEGORY FEE:
                        </h3>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '10px'
                            }}
                        >
                            <div
                                style={{
                                    flex: '1 1 48%',
                                    border: '1px solid #2a4582',
                                    borderRadius: '4px',
                                    backgroundColor: 'rgba(255, 255, 255, 0.7)'
                                }}
                            >
                                <table
                                    style={{
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        fontSize: '14px'
                                    }}
                                >
                                    <thead>
                                        <tr style={{ backgroundColor: '#2a4582', color: 'white' }}>
                                            <th style={{ padding: '8px', border: '1px solid #2a4582', textAlign: 'center' }}>Sl. No</th>
                                            <th style={{ padding: '8px', border: '1px solid #2a4582', textAlign: 'center' }}>
                                                Name of sport
                                            </th>
                                            <th style={{ padding: '8px', border: '1px solid #2a4582', textAlign: 'center' }}>Fee</th>
                                            <th style={{ padding: '8px', border: '1px solid #2a4582', textAlign: 'center' }}>
                                                Put Tick mark
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sports?.map((sport, i) => (
                                            <tr key={sport?.id} style={{ backgroundColor: sport?.id % 2 === 0 ? '#e6e9f0' : 'white' }}>
                                                <td style={{ padding: '8px', border: '1px solid #2a4582', textAlign: 'center' }}>
                                                    {i + 1}
                                                </td>
                                                <td style={{ padding: '8px', border: '1px solid #2a4582' }}>{sport?.name}</td>
                                                <td style={{ padding: '8px', border: '1px solid #2a4582', textAlign: 'center' }}>
                                                    ₹ {sport?.amount}
                                                </td>
                                                <td style={{ padding: '8px', border: '1px solid #2a4582', textAlign: 'center' }}>
                                                    <Checkbox
                                                        id={`sport-${sport?.id}`}
                                                        name="sports"
                                                        value={sport?.id}
                                                        checked={selectedSports?.includes(sport?.id.toString())}
                                                        onChange={(e) => {
                                                            const sportsId = e.target.value;
                                                            const isChecked = e.target.checked;

                                                            if (isChecked) {
                                                                setSelectedSports((prev) => [...prev, sportsId]);
                                                            } else {
                                                                setSelectedSports((prev) => prev.filter((id) => id !== sportsId));
                                                            }
                                                        }}
                                                        style={{
                                                            width: '16px',
                                                            height: '16px',
                                                            cursor: 'pointer'
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginTop: '10px'
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                {!studentData?.interestSports && (
                                    <Typography variant="h4" sx={{ mt: 2 }}>
                                        Total Payable Amount: ₹{totalSportsAmount}
                                    </Typography>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                <Box>
                    <FormLabel component="legend" sx={{ fontWeight: 'bold', fontSize: '0.85rem', mb: 0.5 }}>
                        Sports Participation (Tick)
                    </FormLabel>
                    <FormGroup row>
                        {['States', 'National', 'All India', 'International', 'Others'].map((participation) => (
                            <FormControlLabel
                                key={participation}
                                control={
                                    <Checkbox
                                        value={participation}
                                        sx={{ color: '#2a4582', '&.Mui-checked': { color: '#2a4582' } }}
                                        checked={sportInfo?.participationList?.includes(participation)}
                                        onChange={(event) => {
                                            const { checked, value } = event.target;
                                            setSportInfo((prevState) => {
                                                const data = checked
                                                    ? [...prevState.participationList, value]
                                                    : prevState.participationList.filter((participation) => participation !== value);

                                                return { ...prevState, participationList: data };
                                            });
                                        }}
                                    />
                                }
                                label={participation}
                            />
                        ))}
                    </FormGroup>
                </Box>
                <Grid container spacing={2} mb={2}>
                    <Grid item xs={12}>
                        <LabelledField label="Name of the student:" labelWidth="200px">
                            <CustomTextField value={studentData?.studentName} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LabelledField label="Course:" labelWidth="80px">
                            <CustomTextField value={studentData?.courseDetail?.course?.courseName} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LabelledField label="Roll No:" labelWidth="80px">
                            <CustomTextField value={studentData?.rollNo} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LabelledField label="Contact No:" labelWidth="120px">
                            <CustomTextField value={studentData?.personalDetails?.phone} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LabelledField label="Blood Group:" labelWidth="180px">
                            <CustomTextField value={studentData?.personalDetails?.bloodGroup} />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12}>
                        <LabelledField label="Any Previous Injury:" labelWidth="180px">
                            <CustomTextField
                                value={sportInfo?.injury || studentData?.sportInfo?.injury}
                                onChange={(e) =>
                                    setSportInfo((prevState) => {
                                        const data = e.target.value;
                                        return { ...prevState, injury: data };
                                    })
                                }
                            />
                        </LabelledField>
                    </Grid>
                    <Grid item xs={12} md={6} textAlign={isMobile ? 'center' : 'left'} mt={2}>
                        {(studentData?.studentSignature || studentData?.declarations[0]?.signatureFile) && (
                            <Box display={isMobile ? 'block' : 'flex'} justifyContent="flex-start">
                                <img
                                    src={signature || studentData?.declarations[0]?.signatureFile}
                                    alt="Student"
                                    style={{
                                        maxWidth: '100%',
                                        width: '200px',
                                        height: 'auto',
                                        border: '1px solid #ccc',
                                        borderRadius: 4
                                    }}
                                />
                            </Box>
                        )}
                        <Typography variant="h5">Signature of the Student</Typography>
                    </Grid>
                    <Grid item xs={12} display="flex" justifyContent="space-between">
                        <LabelledField label="Date:" labelWidth="80px">
                            <CustomTextField
                                value={currentDate}
                                InputProps={{
                                    style: {
                                        fontSize: '0.85rem',
                                        padding: 0,
                                        disableUnderline: false,
                                        fontWeight: 500
                                    }
                                }}
                            />
                        </LabelledField>
                        <Typography variant="h5">Signature of the Director of Sports Affairs</Typography>
                    </Grid>
                </Grid>
                <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                    {/* <Button color="error" variant="contained" onClick={() => setOpenSports(true)}>
                    Cancel Subscription
                </Button> */}
                    <Button
                        startIcon={isLoading && <CircularProgress color="error" size="1rem" />}
                        onClick={() => {
                            handleSubscription();
                        }}
                        disabled={isLoading}
                        color="secondary"
                        variant="contained"
                    >
                        {isLoading ? 'Please Wait' : studentData?.interestSports ? 'Update' : 'Submit'}
                    </Button>
                </Box>
            </Paper>
            <Dialog open={openSports} onClose={() => setOpenSports(false)}>
                <DialogTitle>Cancel Subscription</DialogTitle>

                <DialogContent sx={{ width: '500px', p: 3 }}>
                    <Typography variant="body1">
                        Are you sure you want to cancel your subscription? This action cannot be undone.
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenSports(false)} color="secondary" variant="contained">
                        No, keep it
                    </Button>
                    <Button onClick={() => cancelSubscription(sportsSubscriptionId, 'SPORTS')} color="error" variant="contained" autoFocus>
                        Yes, cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </MainCard>
    );
};

export default Sports;
